import React from "react";

import { Grid } from "@material-ui/core";
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';

import AlternateEmailRoundedIcon from '@mui/icons-material/AlternateEmailRounded';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import DeveloperBoardRoundedIcon from '@mui/icons-material/DeveloperBoardRounded';
import AccountBalanceRoundedIcon from '@mui/icons-material/AccountBalanceRounded';

export default function UserDetails({ user, roles }) {
 
  const getAccountIcon = () => {
    if (user.isEboard())
      return (<DeveloperBoardRoundedIcon/>);
    else if (user.isEntity())
      return (<AccountBalanceRoundedIcon/>);
    else
      return (<PersonRoundedIcon/>);
  }


  return (
    <Grid container spacing={2} >
      <Grid item xs={"auto"}>
         <TextField
          variant="outlined" 
          id="id"
          label="Nro de cuenta"
          name="id"
          InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <AccountCircleRoundedIcon />
            </InputAdornment>
            ),
          }}
          value={`#${user.id}`}
          style={{width: 130}}
        />
      </Grid>
      <Grid item xs={true} >
        <TextField
          variant="outlined" 
          id="role"
          label="Tipo de cuenta"
          name="role"
          value={roles.map[user.role].description}
          fullWidth
          InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              { getAccountIcon() }
            </InputAdornment>
            ),
          }}/>
      </Grid>
      <Grid item xs={12} lg={true} >
        <TextField
          variant="outlined" 
          id="email"
          label="Correo electrónico"
          name="email"
          value={user.email}
          fullWidth
          InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <AlternateEmailRoundedIcon />
            </InputAdornment>
            ),
          }}/>
      </Grid>
    </Grid>
  );
}